import React from 'react'
import { Button } from '@paintscout/ui'
import AdditionalWorkOptionCard from './AdditionalWorkOptionCard'
import DividerRow from './DividerRow'
import type { AdditionalWorkOption } from './types'
import type { useAddAdditionalWorkPanelStyles } from './useAddAdditionalWorkPanelStyles'

interface AddAdditionalWorkSelectViewProps {
  options: AdditionalWorkOption[]
  selectedIds: Set<string>
  onToggleOption: (id: string) => void
  onAddSelected: () => void
  onAddLineItem?: () => void
  classes: ReturnType<typeof useAddAdditionalWorkPanelStyles>
}

export default function AddAdditionalWorkSelectView({
  options,
  selectedIds,
  onToggleOption,
  onAddSelected,
  onAddLineItem,
  classes
}: AddAdditionalWorkSelectViewProps) {
  return (
    <>
      <div className={classes.sectionLabel}>Select from options:</div>
      {options.length > 0 && (
        <div className={classes.optionList}>
          {options.map((option) => (
            <AdditionalWorkOptionCard
              key={option.id}
              option={option}
              selected={selectedIds.has(option.id)}
              onToggle={onToggleOption}
              classes={classes}
            />
          ))}
        </div>
      )}
      <Button
        className={classes.addSelectedButton}
        variant="contained"
        onClick={onAddSelected}
        disabled={selectedIds.size === 0}
      >
        {selectedIds.size > 0 ? `Add Selected (${selectedIds.size})` : 'Add Selected'}
      </Button>
      <DividerRow classes={classes} />
      <Button className={classes.addSelectedButton} variant="outlined" onClick={onAddLineItem}>
        + Add Line Item
      </Button>
    </>
  )
}
